import React from 'react';
import styled from 'styled-components';
import Modal from 'react-awesome-modal';
import Loader from 'react-loader';
import { toast } from 'react-toastify';
import ScrollBars from 'react-custom-scrollbars'

import { PROXIED_MEDIABASE } from '../../../../common/constants';

import { ModalContent, ModalRow, AssetItem } from '../EditModal/Modal.styles';
import Handle from '../Handle/Handle.Component';
import withServices from '../../../../HOCs/withServices';
import AssetCollectionOption from '../../../../components/Admin/LessonBuilder/AssetCollections/AssetCollectionOption';


import poster from '../../../../assets/images/lessonbuilder/video.png'

// import { sampleImages } from '../../../../assets/images/lessonbuilder/images';

const StyledImgInput = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 200px;
    width: 100%;
    border: 2px solid rgba(255, 255, 255, .2);
    border-radius: 5px;
`

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    height: 150px;

    input, select, img {
        width: 33%;
        margin-right: 4px;
    }
`

const VideosContainer = styled.div`
    display: flex;
    flex-flow: row wrap;
    height: 540px;
    overflow-y: scroll;
    align-content: flex-start;
    width: 90%;

    img{
        max-width: 100px;
        height: 60px;
        padding: 4px;
    }
`

const Button = styled.button`
    display: ${props => props.show ? 'block     ' : 'none'} ;
    height: 40px;
    width: 90%;
    border-radius: 5px;
    border: 2px #fff solid;
    background-color: rgba(255, 255, 255, .2);
    font: normal normal 22px 'Roboto Condensed';
    text-transform: uppercase;
    color: #fff;
`

class VideoInput extends React.Component {
    state = {
        modalOpen: false,
        showEdit: false,
        videos: null,
        videosLoaded: false,
        videoCollections: null,
        collectionsLoaded: false,
        selectedCollection: null,
        collectionsKeyword: "",
        videoKeyword: ""
    }
    constructor(props) {
        super(props);
        this.chooseVideoCollectionHandler = this.chooseVideoCollectionHandler.bind(this);
    }

    async componentDidMount() {
        const { services: { adminAPI } } = this.props;
        const res = await adminAPI.getAssetCollections();
        if (res.ok) {
            this.setState({ videoCollections: res.data, collectionsLoaded: true });
        }
    }


    toggleEditButtons = () => {
        const { showEdit } = this.state;
        this.setState({ showEdit: !showEdit });
    }

    toggleModal = () => {
        const { modalOpen } = this.state;
        this.setState({ modalOpen: !modalOpen });
    }
    openModal = () => {
        this.setState({ modalOpen: true });
        // query for images
        // const images = sampleImages.images;
        // this.setState({images});
    }
    closeModal = () => {
        this.setState({ modalOpen: false });
    }

    closeModalHandler = (colIdx, value) => {
        this.props.selectVideo(colIdx, `${PROXIED_MEDIABASE}assets/${value}`);
        this.setState({ modalOpen: false });
    }

    changeAlign = (event) => {
        // pass columnIndex, property to change, value to change to
        const value = event.target.value;
        this.props.changeStyleProperty(this.props.columnIndex, 'align', value);
    }

    changeWidth = (event) => {
        const value = event.target.value;
        this.props.changeStyleProperty(this.props.columnIndex, 'size', value);
    }

    deleteAsset = () => {
        this.props.deleteAsset(this.props.columnIndex);
    }
    onSearchChangeHandler = (field, e) => {
        if (field === 'asset') {
            this.setState({ videoKeyword: e.target.value });
        }
        if (field === "collection") {
            this.setState({ collectionsKeyword: e.target.value });
        }
    }

    async chooseVideoCollectionHandler(event) {
        this.setState({ videosLoaded: false, selectedCollection: +event.target.value});
        const res = await this.props.services.adminAPI.getCollectionVideoItems(+event.target.value);
        if (res.ok) {
            console.log("VIdRes: " + JSON.stringify(res.data, null, 2));

            const videos = res.data.assets;
            this.setState({ videos, videosLoaded: true });
        } else {
            toast.error("Videos Not Found!");
        }
    }

    renderCollectionOptions = () => {
        const { collectionsLoaded, videoCollections, selectedCollection, collectionsKeyword } = this.state;
        if (collectionsLoaded) {
            const filteredCollections = videoCollections.filter(item => {
                if (collectionsKeyword === "") {
                    return item
                } else {
                    return item.Name.toLowerCase().includes(collectionsKeyword.toLowerCase())
                }
            })
            return (
                <React.Fragment>
                    {/* <p style={{ color: "white" }}>Choose A Collection Here!</p> */}
                    <input
                        type="text"
                        className="custom-textfield"
                        placeholder="Search Collection Name"
                        value={collectionsKeyword}
                        onChange={this.onSearchChangeHandler.bind(this, 'collection')}
                    />
                    <ScrollBars style={{ height: "70vh" }} className="hide-x">
                        {filteredCollections.map(collection => {
                            return (
                                <AssetCollectionOption
                                    collectionID={collection.AssetCollectionId}
                                    selectedCollection={selectedCollection}
                                    collectionName={collection.Name}
                                    collectionDescription={collection.Description}
                                    onCollectionChange={this.chooseVideoCollectionHandler}
                                />
                            )
                        })}
                    </ScrollBars>
                </React.Fragment>

            );
        } else {
            return <Loader color="#acff2430" />;
        }
    };

    renderVideosContainer = () => {
        const { videos, videosLoaded, videoKeyword } = this.state;
        if (videosLoaded) {
            const filteredVideos = videos.filter(item => {
                if (videoKeyword === "") {
                    return item
                } else {
                    return item.Title.toLowerCase().includes(videoKeyword.toLowerCase())
                }
            })
            return (
                <React.Fragment>
                    {/* <p style={{ color: "white" }}>Choose An Image Here!</p> */}
                    <input
                        style={{ width: "75%" }}
                        type="text"
                        className="custom-textfield"
                        placeholder="Search Asset Name"
                        value={this.state.videoKeyword}
                        onChange={this.onSearchChangeHandler.bind(this, 'asset')}
                    />
                    <VideosContainer>
                        {filteredVideos.map((vid, idx) => {
                            return (
                                <AssetItem border={true}>
                                    <video key={idx} width="200" height="auto" src={`${PROXIED_MEDIABASE}assets/${vid.FileName}`} onClick={this.closeModalHandler.bind(this, this.props.columnIndex, vid.FileName)} />
                                    <p className="col-asset-name">{vid.Title}</p>
                                </AssetItem>
                            );
                        })}
                    </VideosContainer>
                </React.Fragment>
            );

        } else {
            return (
                <VideosContainer>
                    <p style={{ color: "#fff", font: "italic bold 26px 'Roboto", marginTop: "35%", textAlign: "center" }}>
                        Please choose a Video Collection First
        </p>
                </VideosContainer>

            );
        }
    }

    render() {
        // const { images } = this.state;
        return (
            <StyledImgInput>
                <Modal visible={this.state.modalOpen} width="90%" height="85%" effect="fadeInUp" onClickAway={() => this.closeModal()}>
                    <ModalContent>
                        <ModalRow>
                            <div className="modal-left">{this.renderCollectionOptions()}</div>
                            <div className="modal-right"> {this.renderVideosContainer()}</div>
                        </ModalRow>
                                            </ModalContent>
                </Modal>
                <Handle type="VIDEO" deleteAsset={this.deleteAsset} />
                <ContentWrapper>
                    <input className="custom-textfield lb-textfield" type="number" name="width" id="width" placeholder={this.props.size} onChange={this.changeWidth} />
                    <select className="custom-select lb-select" name="" id="" onChange={this.changeAlign}>
                        <option selected={this.props.alignment === "center"} value="center">Center</option>
                        <option selected={this.props.alignment === "left"} value="left">Left</option>
                        <option selected={this.props.alignment === "right"} value="right">Right</option>
                    </select>
                    <div onMouseEnter={this.toggleEditButtons} onMouseLeave={this.toggleEditButtons} >
                        <video width="80" height="auto" src={this.props.url} poster={poster} />
                        <Button show={this.state.showEdit} onClick={this.openModal}>Edit</Button>
                    </div>
                </ContentWrapper>
            </StyledImgInput>
        )
    }
}

export default withServices(VideoInput);


// WEBPACK FOOTER //
// ./src/components/Admin/LessonBuilder/VideoInput/VideoInput.Component.jsx